import React, { useEffect } from 'react';
import { OTPVerificationForm } from '../../../shared/otpVerificationForm/OTPVerificationForm';
import {
    Contact,
    useResendEmailResetPasswordMutation,
    useResetPasswordSubmitOtpMutation
} from '../../../slices/auth-api.slice';
import { useSelector } from 'react-redux';
import { selectUserEmail } from '../../../slices/login.slice';
import { useHistory } from 'react-router-dom';
import { ERROR_PATH } from '../../../react-router-paths';
import { UNAUTH_FLOW } from '../../../shared/error-page/error-page';

interface VerifyEmailOtpStepProps {
    contacts: Array<Contact>;
    onNext: () => void;
}

export function VerifyEmailOtpStep({ contacts, onNext }: VerifyEmailOtpStepProps) {
    const history = useHistory();

    const [resetPasswordVerifyEmailOtp, resetPasswordVerifyEmailMutation] = useResetPasswordSubmitOtpMutation();
    const [resendEmailResetPassword, resendEmailResetPasswordMutation] = useResendEmailResetPasswordMutation();

    const userEmail = useSelector(selectUserEmail);

    const emailContact = contacts.find(contact => contact.contactType === 'email');

    useEffect(() => {
        if (resetPasswordVerifyEmailMutation.isSuccess) {
            onNext();
        }

        if (
            (resetPasswordVerifyEmailMutation.isError &&
                // @ts-ignore
                resetPasswordVerifyEmailMutation.error.data.errorCode === 'UPC-1054') ||
            resendEmailResetPasswordMutation.isError
        ) {
            history.replace({
                pathname: ERROR_PATH,
                state: {
                    context: UNAUTH_FLOW
                }
            });
        }
    }, [history, resetPasswordVerifyEmailMutation, resendEmailResetPasswordMutation, onNext]);

    function onResend() {
        resendEmailResetPassword({ contactId: emailContact?.contactId });
    }

    function onSubmit({ passcode }) {
        resetPasswordVerifyEmailOtp({ passcode, email: userEmail });
    }

    return (
        <OTPVerificationForm
            errorPath={ERROR_PATH}
            onResend={onResend}
            onSubmit={onSubmit}
            disabled={resetPasswordVerifyEmailMutation.isLoading || resendEmailResetPasswordMutation.isLoading}
            otpContact={emailContact}
            mutation={resetPasswordVerifyEmailMutation}
        />
    );
}
